import { getEnabledElement } from './enabledElements.js';
import getTransform from './internal/getTransform.js';

/**
 * Converts a point in the canvas coordinate system to the pixel coordinate system
 * system.  This can be used to reset tools' image coordinates after modifications
 * have been made in canvas space (e.g. moving a tool by a few cm, independent of
 * image resolution).
 *
 * @param {HTMLElement} element The Cornerstone element within which the input point lies
 * @param {{x: number, y: number}} pt The input point in the canvas coordinate system
 * @returns {{x: number, y: number}} The transformed point in the pixel coordinate system
 * @memberof PixelCoordinateSystem
 */
function canvasToPixel(element, pt) {
  const enabledElement = getEnabledElement(element);
  const transform = getTransform(enabledElement);

  transform.invert();

  return transform.transformPoint(pt.x, pt.y);
}

export default canvasToPixel;
